module.exports = __webpack_public_path__ + "img/close.b44bc516.svg";